export default __webpack_public_path__ + "static/media/image_1-removebg-preview 1.ede78aae.svg";